<template>
    <form @submit.prevent="submit" data-position="right">
        <input class="auth-email auth-layout-login-form-text auth-layout-secondary"
               v-model="email" id="email" type="text" name="email"
               :class="{ valid: isValid('email'), invalid: errors.has('email') }"
               :data-vv-as="'E-Mail' | translate"
               v-validate="'required|email'"
               autocomplete="off"
               @focusout="validateField('email')"
               @animationstart="onAnimationStart"
               :placeholder="'E-Mail' | translate"
        />
        <label :data-error="errors.first('email')"
               class="auth-email auth-layout-text-and-icon active">
        </label>

        <input class="auth-password auth-layout-login-form-text auth-layout-secondary"
               v-model="password" @keypress="checkForCaps" id="password" type="password" name="password"
               autocomplete="off"
               :class="{  valid: isValid('password'), invalid: errors.has('password') }"
               v-validate="'required|min:' + passwordMinLength"
               @focusout="validateField('password')"
               :data-vv-as="'Passwort' | translate"
               @animationstart="onAnimationStart"
               :placeholder="'Passwort' | translate"
               minlength="6"
        />

        <label :data-error="errors.first('password')"
               class="auth-password auth-layout-text-and-icon active">
        </label>
        <button
            class="auth-login wave auth-layout-tertiary auth-layout-button-text auth-layout-tertiary-border-color"
            :class="{'disabled-button' : isButtonDisabled }"
            type="submit"
            :disabled="isButtonDisabled"
        >
            {{ 'Anmelden' | translate }}
        </button>

        <p class="small-small">
            <router-link class="forget-password auth-layout-tertiary-font-color"
                         :to="{name:'ForgotPassword'}">
                {{ 'Passwort vergessen?' | translate }}
            </router-link>
        </p>
        <!--TODO Contact Button, wenn Seite dafür vorhanden-->
    </form>
</template>

<style scoped>

input:-webkit-autofill {
    background: 0 none !important;
}

input:-webkit-autofill::placeholder,
input:-webkit-autofill::-webkit-input-placeholder {
    display: none;
}

.input-field label:not(.active):after {
    font-size: 0.8rem;
    -webkit-transform: translateY(-140%);
    -moz-transform: translateY(-140%);
    -ms-transform: translateY(-140%);
    -o-transform: translateY(-140%);
    transform: translateY(-140%);
}

.caps-warning::after {
    content: attr(caps-warning);
    position: absolute;
    top: 0;
    left: 0;
}

@keyframes onAutoFillStart {
    from {
    }
    to {
    }
}

@keyframes onAutoFillCancel {
    from {
    }
    to {
    }
}

input:-webkit-autofill {
    animation-name: onAutoFillStart;
}

input:not(:-webkit-autofill) {
    animation-name: onAutoFillCancel;
}
</style>

<script>
import {translate} from 'pf/filter'
import Noty from "noty";

export default {
    mounted() {
        if (window.browser === 'IE11' || window.browser === 'deprecatedIE') {
            alert(translate('Die Funktionalität kann in diesem Browser eingeschränkt sein. Nutze einen aktuellen Browser für das beste Nutzererlebnis.'));
        } else if (window.browser === 'Safari' && window.browserVersion < 10) {
            alert(translate('Dein Browser wird nicht mehr unterstützt. Nutze einen aktuellen Browser für das beste Nutzererlebnis.'));
        }
    },
    filters: {
        translate
    },
    data() {
        return {
            passwordMinLength: 6,
            capslock: false,
        }
    },
    methods: {
        validateField(field) {
            if (!this[field]) {
                this.$validator.errors.clear(field);
            }
            this.$validator.validate(field);
        },
        onAnimationStart({target, animationName}) {
            switch (animationName) {
                case 'onAutoFillStart':
                    setTimeout(() => target.nextElementSibling.classList.add('active'), 250);
                case 'onAutoFillCancel':
            }
        },
        validate() {
            return this.$validator.validate();
        },
        submit() {
            this.validate()
                .then((success) => {
                    if (!success) return;

                    this.$store.dispatch('login')
                        .then((response) => {
                            window.location.pathname = response.data.href;
                        })
                        .catch(({response: {data}}) => {
                            this.$validator.errors.clear();
                            this.$validator.errors.add({
                                field: 'password',
                                msg: translate('E-Mail oder Passwort falsch')
                            });
                        });

                });
        },
        checkForCaps(e) {
            const key = String.fromCharCode(e.which);

            if (!/[a-zA-Z]/.test(key)) return;

            if ((key.toUpperCase() === key && !e.shiftKey) ||
                (key.toLowerCase() === key && e.shiftKey)) {
                if (!this.capslock) {
                    new Noty ({
                        type: "warning",
                        theme: "mint",
                        layout:"topRight",
                        text: translate('Feststelltaste ist aktiv!'),
                        timeout: 6000,
                    }).show();
                    this.capslock = true;
                }
            } else {
                this.capslock = false;
            }
        },
        isValid(key) {
            return !this.errors.has(key) && this.fields[key] && this.fields[key].touched;
        },
    },
    computed: {
        isButtonDisabled() {
            const isEmailValid = !this.errors.has('email');
            const isPasswordValid = !this.errors.has('password');
            return !(isEmailValid && isPasswordValid);
        },
        email: {
            set(value) {
                this.$store.commit('setEmail', value);
            },
            get() {
                return this.$store.state.email;
            }
        },
        password: {
            set(value) {
                this.$store.commit('setPassword', value);
            },
            get() {
                return this.$store.state.password;
            }
        }
    }
}
</script>
